import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0badca6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-center my-2" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sr-only" })
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 p-0" }
const _hoisted_6 = { class: "row m-0 mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "line"
}
const _hoisted_8 = {
  key: 1,
  class: "col-6 pe-5"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col sectionColumn" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = {
  key: 0,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.ready)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.ready)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.createJob._fields.steps, (step, index) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (index != _ctx.createJob.summeryIndex)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.createJob.steps[index]), 1),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (item.type == 'new_row')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                            : _createCommentVNode("", true),
                          (item.label && item.type !== 'button')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                  _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                      _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("b", null, _toDisplayString(item.label), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_13, [
                                        _createTextVNode(_toDisplayString(item.fakeValue) + " ", 1),
                                        ((item.fakeValue == '' || item.fakeValue == null || typeof item.fakeValue === 'undefined'))
                                          ? (_openBlock(), _createElementBlock("em", _hoisted_14, "Ikke udfyldt"))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 256))
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]))
        }), 256))
      : _createCommentVNode("", true)
  ], 64))
}